import {Component, Element, h, Host, Prop} from '@stencil/core'
import {FlexClass, FlexSizesType} from './constants'
import {govHost} from '../../helpers/Dom/template'
import {GovHost} from '../../helpers/Dom/template.types'

@Component({
	tag: 'gov-flex',
})
export class GovFlex {
	private h: GovHost

	constructor() {
		this.h = govHost(this.host)
	}

	@Element() host: HTMLGovGridElement

	/**
	 * Controls the flex direction of the container.
	 */
	@Prop({reflect: true}) direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse' = 'row';

	/**
	 * Defines how the browser distributes space between and around content items along the main axis.
	 */
	@Prop({
		attribute: 'justify-content',
		reflect: true
	}) justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';

	/**
	 * Aligns flex items along the cross axis.
	 */
	@Prop({
		attribute: 'align-items',
		reflect: true
	}) alignItems?: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline';

	/**
	 * Controls whether the flex container is a single-line or multi-line flex container.
	 */
	@Prop({reflect: true}) wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';

	/**
	 * Aligns the flex container's lines within when there is extra space in the cross-axis.
	 */
	@Prop({
		attribute: 'align-content',
		reflect: true
	}) alignContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'stretch';

	/**
	 * Sets the alignment of the flex container’s children along the flex container’s cross axis, overriding the `align-items` property for individual flex items.
	 */
	@Prop({
		attribute: 'align-self',
		reflect: true
	}) alignSelf?: 'auto' | 'normal' | 'self-start' | 'self-end' | 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch' | 'anchor-center';

	/**
	 * The gap property creates consistent spacing between flex items in the container.
	 */
	@Prop({
		attribute: 'gap',
		reflect: true
	}) gap?: FlexSizesType;

	/**
	 * Option to turn off responsive
	 */
	@Prop({reflect: true}) readonly responsive: string = "true"

	render() {
		return (
			<Host class={this.h.classes(FlexClass.root)}>
				<slot></slot>
			</Host>
		)
	}
}
